import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent } from 'react';
import { getBookingUrl } from '../../../../../../services/getBookingUrl';
import { BookButton } from '../BookButton';

type DateRequestButtonProps = {
    course: PublicCourse;
    educator: PublicEducator;
    isEmbed: boolean;
};

export const DateRequestButton: FunctionComponent<DateRequestButtonProps> = ({
    course,
    educator,
    isEmbed,
}) => {
    return (
        <BookButton
            href={getBookingUrl({
                courseSlug: course.slug,
                courseType: course.type,
                educatorSlug: educator.slug,
                isEmbed,
                isRequest: true,
            })}
            preset="primary"
            buttonLabel="Request a Date"
        />
    );
};
